import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

import { Button, DrawerBody, DrawerFooter, IconButton, Text, useRebrand } from '@growtherapy/sprout-ui';

import { DrawerHeader } from '../../components/DrawerHeader';

type CSSRSFormProps = {
  onClickBackButton: () => void;
  onSubmit: () => Promise<void>;
  connectedMeasureComponent: React.ReactNode;
  isLoading?: boolean;
};

const CSSRSFormHeader = ({ onClickBackButton }: { onClickBackButton: () => void }) => {
  return (
    <DrawerHeader>
      <div className='flex items-center'>
        <IconButton
          onClick={onClickBackButton}
          className='mr-4 w-8 h-8 flex justify-center items-center'
          iconSize='xs'
          aria-label='Go back'
          iconDefinition={faArrowLeft}
        />
        <Text variant='lg' className='rebrand:text-text-inverse'>
          C-SSRS – Suicide Risk
        </Text>
      </div>
    </DrawerHeader>
  );
};

export const CSSRSForm = ({ onClickBackButton, onSubmit, connectedMeasureComponent, isLoading }: CSSRSFormProps) => {
  const isRebrand = useRebrand();

  return (
    <>
      <CSSRSFormHeader onClickBackButton={onClickBackButton} />
      <DrawerBody className='inc_297__fix_radio_accent'>{connectedMeasureComponent}</DrawerBody>
      <DrawerFooter>
        <Button loading={isLoading} onClick={onSubmit} className='!ml-auto' use={isRebrand ? 'secondary' : 'primary'}>
          Submit
        </Button>
      </DrawerFooter>
    </>
  );
};
